module.exports = __webpack_public_path__ + "media/src/images/abouts/items/delivery/PIZZA-LA-b69415ff7c892f1ec570ff2f4b2a7bd9.jpg";